<template>
    <div id="page-top" class="row"
         :style="{'background-image': getBannerImageUrl() }">
        <div class="apply-admission">
            <div class="apply-admission-wrap type2 bd-type1 accent-primary-bs accent-primary-bd">
                <div class="apply-admission-inner">
                    <h2 class="title text-center">
                        <span>Forgot password</span>
                    </h2>
                    <div class="caption text-center">
                        Let's get your password reset.
                        <br />
                        <br />
                        Provide us with your email address and we'll send you a reset link and instructions.
                    </div>
                    <div>
                        <div class="apply-sent apply-sent-style1" style="padding-top:40px">
                            <div class="form-sent-main">
                                <input :class="{ 'not-valid': v_email }" v-model="email" type="text" placeholder="Enter email address...">
                            </div>
                        </div>
                        <div class="apply-sent apply-sent-style1">

                            <div style="text-align: center; margin-top: 25px">
                                <button v-on:click="login" class="sign-up-main btn-site-primary" href="#loader-modal" data-toggle="modal">Reset</button>
                            </div>
                        </div>
                        <br />
                        <div v-if="v_summary" class="alert alert-danger" style="text-align: center;">
                            {{ v_summary }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>

    #page-top {
        background-repeat: no-repeat;
        background-size: cover;
    }

    .apply-admission {
        margin-top: 80px;
        left: 15%;
        position: relative;
        width: 70%;
        z-index: 100;
        margin-bottom: 20px;
    }

    .apply-admission-wrap {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
    }

    .register-link {
        color: white;
        text-decoration: underline;
        font-size: 20px;
    }

    .not-valid {
        border-color: rgb(255, 95, 96);
        border-width: 3px;
    }

    .alert-danger {
        background-color: rgb(255, 95, 96);
        border-color: rgb(255, 95, 96);
        color: white;
    }
</style>
<script>
    export default {
        name: 'Forgot',
        components: {
        },
        data: function () {
            return {
                email: "",

                v_email: false,
                v_summary: ""
            }
        },
        computed: {
            siteDesign() {
                return this.$store.getters.getSiteDesign;
            },
        },
        methods: {
            validate: function () {
                this.v_email = false;
                this.v_summary = null;

                if (!this.isValidEmail(this.email)) {
                    this.v_summary = "Please enter a valid email address";
                    this.v_email = true;
                    return false;
                }

                return true;
            },
            getBannerImageUrl: function () { 
                if (this.siteDesign && this.siteDesign.homePage && this.siteDesign.homePage.bannerFileName) {
                    return `url('https://fabricfour.blob.core.windows.net/mhslearning-upload/${this.siteDesign.homePage.bannerFileName}')`;
                }

                return "url('/wwwroot/images/home/header4.jpg')";
            },
            async login() {
                try {
                    if (this.validate()) {
                        await this.web('/auth/forgot', "Requesting reset link", {
                            email: this.email,
                        }, [400]);

                        this.$router.replace("/auth/forgotSuccess");
                    }
                }
                catch (e) {
                    if (e.response.status == 400) {
                        this.v_summary = e.response.data;
                    }
                }
            }
        },
        mounted: function () {
            this.$store.commit("breadCrumbs", null);
        }
    };
</script>
